import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20projector%20on%20dark%20warm%20amber%20background%2C%20vintage%20movie%20aesthetic%2C%20golden%20accents%2C%20dramatic%20lighting%2C%20elegant%20cinema%20atmosphere%2C%20rich%20warm%20tones&width=600&height=400&seq=cat-movie&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20flat%20screen%20television%20in%20cozy%20living%20room%20with%20warm%20ambient%20lighting%2C%20evening%20mood%2C%20comfortable%20home%20theater%20setup%2C%20soft%20golden%20glow%2C%20inviting%20atmosphere&width=600&height=400&seq=cat-tv&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Vibrant%20anime%20art%20studio%20scene%20with%20colorful%20illustrations%20on%20walls%2C%20drawing%20tablet%2C%20warm%20creative%20atmosphere%2C%20Japanese%20manga%20aesthetic%2C%20soft%20ambient%20lighting&width=600&height=400&seq=cat-anime&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Bright%20television%20studio%20stage%20with%20colorful%20lighting%20rigs%20and%20cameras%2C%20entertainment%20show%20production%20setup%2C%20warm%20golden%20spotlights%2C%20energetic%20atmosphere&width=600&height=400&seq=cat-variety&orientation=landscape',
];

const categoryDescs = [
  '动作、科幻、喜剧、爱情等各类大片一网打尽',
  '热门国产剧、韩剧、美剧同步追更',
  '日漫新番、国漫精品、经典番剧应有尽有',
  '热门综艺、真人秀、音乐竞演节目不间断',
];

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            分类浏览
          </h2>
          <p className="text-foreground-500 text-sm">按类型快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={categoryImages[index]}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                    <i className={`${cat.icon} text-background-50 text-sm`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-lg text-background-50">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-background-200 text-xs pl-10">
                  {categoryDescs[index]}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}